import * as React from "react";
import { useState } from "react";
import { useDebugSettings } from "conference/tools";
import WindowPanel from "conference/components/WindowPanel";
import { useSession, useSipClient } from "@dvrt/web-phone-client";
import { Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useInterval } from "@dvrt/react-tools";
import { defineMessage } from "react-intl";

const ParticipantTable = () => {
    const context = useSession();
    return (
        <div>
            <Typography>Participant list from SDP ({context.participants.length}):</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>CSRC</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>cName</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {context.participants.map((p) => (
                        <TableRow key={p.csrc}>
                            <TableCell>{p.csrc}</TableCell>
                            <TableCell>{p.name}</TableCell>
                            <TableCell>{p.cname}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

const ContributingSourceTable = () => {
    const sipClient = useSipClient();
    const [csrcList, setCsrcList] = useState<RTCRtpContributingSource[]>([]);
    const [interval, setInterval] = useState(1000);
    const [intervalValue, setIntervalValue] = useState(interval);

    useInterval(() => {
        const receivers = sipClient.session.connection.getReceivers();
        const newList = [];
        for (const recv of receivers) {
            if (recv.track.kind !== "audio") continue;
            newList.push(...recv.getContributingSources());
        }
        setCsrcList(newList);
    }, interval);

    return (
        <div style={{ marginTop: "1em" }}>
            <Typography style={{ display: "flex", alignItems: "center" }} component="div">
                <div style={{ flexGrow: 1, marginRight: "1em" }}>
                    RTP Contributing Source list from receivers ({csrcList.length})
                </div>
                <TextField
                    value={intervalValue}
                    type="number"
                    onChange={(event) => setIntervalValue(parseInt(event.target.value))}
                    onBlur={() => setInterval(intervalValue)}
                    margin="dense"
                    size="small"
                    variant="outlined"
                    label="Polling interval (ms)"
                />
            </Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Source</TableCell>
                        <TableCell>Timestamp</TableCell>
                        <TableCell>RTP timestamp</TableCell>
                        <TableCell>Audio level</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {csrcList.map((csrc) => (
                        <TableRow key={csrc.source}>
                            <TableCell>{csrc.source}</TableCell>
                            <TableCell>{csrc.timestamp}</TableCell>
                            <TableCell>{csrc.rtpTimestamp}</TableCell>
                            <TableCell>{csrc.audioLevel}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

const SpeakerListInfoDialog = () => {
    const debugSettings = useDebugSettings();

    return (
        <WindowPanel
            show={debugSettings.showSpeakerListInfoDialog && debugSettings.enabled}
            title={defineMessage({ id: "debug.speakerList.title", defaultMessage: "Speaker list debug panel" })}
            close={() => {
                debugSettings.showSpeakerListInfoDialog = false;
            }}
        >
            <div>
                <ParticipantTable />
                <ContributingSourceTable />
            </div>
        </WindowPanel>
    );
};

export default SpeakerListInfoDialog;
